var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[(_vm.loading)?_c('Loader'):_c('Order',{attrs:{"document":_vm.documentUrl}}),(_vm.hasError)?_c('ErrorModal',{attrs:{"error":_vm.error,"retry":_vm.retry}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }